export default "__VITE_ASSET__B0G6VNqS__"